export default {
  name: { id: 'name' },
  siteType: { id: 'site_type' },
  siteGroups: { id: 'app_site_groups' },
  siep: { id: 'siep' },
  cmCode: { id: 'cm_code' },
  active: { id: 'active' },
  visible: { id: 'visible' },
  latitude: { id: 'latitude' },
  longitude: { id: 'longitude' },
  siteInfo: { id: 'site_info' },
  saveInfo: { id: 'save_info' },
  locationInfo: { id: 'location_info' },
}
